import React from 'react';
import PropTypes from 'prop-types';

function GrantsList({ permissions, grants, editing }) {
    return (
        <ul>
            {
                grants.map(
                    grant => (
                        <li key={ grant.get('permission') }>
                            { grant.get('id') }
                            { editing ? <input type="checkbox" /> : void 0 }
                            { permissions.getIn([ grant.get('permission'), 'name' ]) }
                        </li>
                    )
                ).toArray()
            }
        </ul>
    );
}

export default GrantsList;
